import './GradientOrbs.scss';

/**
 * Auth-page backdrop. Despite the legacy class name, this is no longer a
 * cluster of consumer-style gradient orbs — it's an operator-console
 * backdrop: dim vignette + horizon glow at the bottom edge + a faint
 * radar arc in one corner + scan-line texture. Tuned to read as "command
 * surface" rather than "SaaS marketing site".
 */
export const GradientOrbs = () => {
  return (
    <div className="gradient-orbs" aria-hidden="true">
      <div className="gradient-orbs__vignette" />
      <div className="gradient-orbs__horizon" />
      <div className="gradient-orbs__radar" />
      <div className="gradient-orbs__scanlines" />
    </div>
  );
};
